module.exports = __webpack_public_path__ + "img/Store-Active-Dark.e361dda.svg";